import { NgModule } from "@angular/core";
import { Ng2StateDeclaration, UIRouterModule } from "@uirouter/angular";
import { ExampleWhiteboardsComponent } from "@webapp/examples/example-whiteboards/example-whiteboards.component";
import { ExampleButtonsComponent } from "@webapp/examples/example-buttons/example-buttons.component";
import { ExampleIconsComponent } from "@webapp/examples/example-icons/example-icons.component";
import { ExampleModalComponent } from "@webapp/examples/example-modals/example-modal.component";
import { ExampleDividerComponent } from "@webapp/examples/example-divider/example-divider.component";
import { ExamplePopoverComponent } from "@webapp/examples/example-popover/example-popover.component";
import { ExampleSpinComponent } from "@webapp/examples/example-spin/example-spin.component";
import { ExamplePermissionsComponent } from "@webapp/examples/example-permissions/example-permissions.component";
import { ExampleMenuComponent } from "@webapp/examples/example-menu/example-menu.component";
import { ExampleSelectComponent } from "@webapp/examples/example-select/example-select.component";
import { ExampleGridComponent } from "@webapp/examples/example-grid/example-grid.component";
import { ExampleDrawerComponent } from "@webapp/examples/example-drawer/example-drawer.component";

const exampleStateWhiteboard: Ng2StateDeclaration = {
  name: "gh.examples.whiteboards",
  url: "/whiteboards",
  component: ExampleWhiteboardsComponent,
};

const exampleButtons: Ng2StateDeclaration = {
  name: "gh.examples.buttons",
  url: "/buttons",
  component: ExampleButtonsComponent,
};
const exampleGrid: Ng2StateDeclaration = {
  name: "gh.examples.grid",
  url: "/grid",
  component: ExampleGridComponent,
};
const exampleSelect: Ng2StateDeclaration = {
  name: "gh.examples.select",
  url: "/select",
  component: ExampleSelectComponent,
};
const exampleDrawers: Ng2StateDeclaration = {
  name: "gh.examples.drawers",
  url: "/drawers",
  component: ExampleDrawerComponent,
};
const exampleModals: Ng2StateDeclaration = {
  name: "gh.examples.modals",
  url: "/modals",
  component: ExampleModalComponent,
};
const examplePopover: Ng2StateDeclaration = {
  name: "gh.examples.popovers",
  url: "/popovers",
  component: ExamplePopoverComponent,
};
const exampleIcons: Ng2StateDeclaration = {
  name: "gh.examples.icons",
  url: "/icons",
  component: ExampleIconsComponent,
};
const exampleDivider: Ng2StateDeclaration = {
  name: "gh.examples.divider",
  url: "/divider",
  component: ExampleDividerComponent,
};

const examplePermissions: Ng2StateDeclaration = {
  name: "gh.examples.permissions",
  url: "/permissions",
  component: ExamplePermissionsComponent,
};

const exampleMenu: Ng2StateDeclaration = {
  name: "gh.examples.menu",
  url: "/menu",
  component: ExampleMenuComponent,
};
const exampleSpin: Ng2StateDeclaration = {
  name: "gh.examples.spin",
  url: "/spin",
  component: ExampleSpinComponent,
};

const routes = [
  exampleMenu,
  examplePermissions,
  examplePopover,
  exampleModals,
  exampleDrawers,
  exampleIcons,
  exampleButtons,
  exampleStateWhiteboard,
  exampleDivider,
  exampleSpin,
  exampleSelect,
  exampleGrid,
];

@NgModule({
  imports: [UIRouterModule.forChild({ states: routes })],
  exports: [UIRouterModule],
})
export class ExamplesRoutingModule {}
